import { diffHydrateFiles } from '~/utils/uploaderAdapter';
import type { HydrateFile } from '@magicdoorinc/ui';
import type { AddBillFilePayload } from '~/repositories/billRepository';

type BillFileSyncRepo = {
  deleteBillFiles: (billId: string, fileIds: string[]) => Promise<void>;
  uploadBillFiles: (billId: string, files: File[]) => Promise<string[]>;
  addBillFile: (billId: string, files: AddBillFilePayload[]) => Promise<unknown>;
};

export const syncBillFileChanges = async (repo: BillFileSyncRepo, billId: string, files: HydrateFile[]) => {
  const { newFiles, deletedFileIds } = diffHydrateFiles(files);

  const [, uploadSessionIds] = await Promise.all([
    deletedFileIds.length > 0 ? repo.deleteBillFiles(billId, deletedFileIds) : Promise.resolve(),
    newFiles.length > 0
      ? repo.uploadBillFiles(
          billId,
          newFiles.map((file) => file.rawFile!)
        )
      : Promise.resolve([]),
  ]);

  if (uploadSessionIds.length === 0) {
    return;
  }

  await repo.addBillFile(
    billId,
    uploadSessionIds.map((uploadSessionId, index) => ({
      uploadSessionId,
      description: newFiles[index]?.name,
    }))
  );
};
